import soc_main_image from "../../components/ProgramCatalog/assets/system-on-a-chip-design-workshop.webp";
import Abarajithan from "../../components/CoursePage/assets/instructor-img/Abarajithan Gnaneswaran.webp";
import kithmin from "../../components/CoursePage/assets/instructor-img/Kithmin.jpg";
import udara from "../../components/CoursePage/assets/instructor-img/Udara_Mendis.jpg";
import subodha from "../../components/CoursePage/assets/instructor-img/Subodha Charles.webp";
import anuki from "../../components/CoursePage/assets/instructor-img/Anuki_Pasqual.jpg";
import dinuka from "../../components/CoursePage/assets/instructor-img/dinuka.jpg";
import socFlyer from "../../components/CoursePage/assets/system-on-a-chip-design-workshop.jpg";
import { ECourseStatus, ICourse } from "../utils/utils";

export const systemOnAChipDesignWorkshop: ICourse = {
  header: {
    courseImage: soc_main_image,
    programCategory: "Workshop",
    difficultyLevel: "Beginner",
    courseTitle: "System-on-a-Chip (SoC) Design Workshop",
    specialization: "Free Workshop",
    courseDescription:
      "Dive into the world of high-performance hardware design with Skill Surf’s intensive four-day free workshop! This hands-on workshop series guides you through the complete lifecycle of accelerator design, from building a Vector Multiply Accumulate (MAC) unit and mastering AXI protocols to implementing a full Systolic Array. You’ll gain practical experience with DMA controllers, firmware development, and rigorous simulation testing, culminating in a real-world FPGA implementation using the ZYNQ ARM processor and Ibex RISC-V integration. Whether you are looking to sharpen your RTL skills or explore hardware-software co-design, this workshop series can help bridge the gap between architectural theory and silicon-ready reality.",
    registerButton: "Registration Closed!",
    registerLink: "",
    secondaryName: "",
  },
  headerSecondSection: {
    starCount: 0,
    reviewCount: 0,
    registrationDeadline: "Registration Closed",
    parameterOne: "Registration Closed",
    parameterTwo: "",
    parameterThree: "New Workshop",
    collaborationLogos: [],
  },
  courseOutline: [
    {
      session: "Day 1 ",
      sessionContent: [
        {
          heading: "25th April | Morning Session (9 am to 11 am IST) ",
          description: "",
          subContent: [
            {
              heading: "",
              description: "Keynote Speech (Dr. Dinuka Kudavithana) ",
            },
            {
              heading: "",
              description: "Developing a Vector Multiply Accumulate Unit",
            },
            {
              heading: "",
              description: "AXI Stream and making the MAC AXI stream",
            },
            {
              heading: "",
              description: "DMAs & Full AXI protocol",
            },
          ],
        },
      ],
    },
    {
      session: "Day 2",
      sessionContent: [
        {
          heading: "26th April |  Morning Session (9 am to 11 am IST)",
          description: "",
          subContent: [
            {
              heading: "",
              description: "DMA controller, register file, firmware",
            },
            {
              heading: "",
              description: "Full Testbench",
            },
            {
              heading: "",
              description: "Testing everything in simulation",
            },
          ],
        },
      ],
    },
    {
      session: "Day 3 ",
      sessionContent: [
        {
          heading: " 2nd May |  Morning Session (9 am to 11 am IST)",
          description: "",
          subContent: [
            {
              heading: "",
              description: "Systolic Array in System Verilog",
            },
            {
              heading: "",
              description: "Firmware for a Systolic Array",
            },
          ],
        },
      ],
    },
    {
      session: "Day 4 ",
      sessionContent: [
        {
          heading: "3rd May |  Morning Session (9 am to 11 am IST)",
          description: "",
          subContent: [
            {
              heading: "",
              description:
                "FPGA implementation with ZYNQ processor (ARM) and testing",
            },
            {
              heading: "",
              description: "Ibex RISC-V integration",
            },
          ],
        },
      ],
    },

    {
      session: "",
      sessionContent: [
        {
          heading: "",
          description:
            "Conducted via Zoom in English medium. Sinhala and Tamil explanations are given based on participant requests.",
          subContent: [],
        },
      ],
    },
  ],
  faqs: [],
  experts: [
    {
      image: Abarajithan,
      name: "Mr. Abarajithan Gnaneswaran",
      designation: "PhD Candidate, University of California San Diego, USA",
    },
    {
      image: kithmin,
      name: "Mr. Kithmin Wickremasinghe",
      designation: "MASc, Electrical and Computer Eng., UBC, Canada",
    },

    {
      image: udara,
      name: "Ms. Udara Mendis",
      designation: "Double Degree Master's Student, TUHH, Germany",
    },

    {
      image: anuki,
      name: "Ms. Anuki Pasqual",
      designation: "Firmware Engineer",
    },
    {
      image: dinuka,
      name: "Dr. Dinuka Kudawithana",
      designation: "Staff Engineer (Systems) in IC Design at Broadcom Ltd.",
    },
    {
      image: subodha,
      name: "Dr. Subodha Charles",
      designation: "Senior Lecturer, ENTC, UoM",
    },
  ],
  studentReviews: [
    "On the 1st day, when I saw the registration details, I went through the course curriculum and I joined the course with an expectation. The team fulfilled my expectations 100%.",
    "The course is very interesting and provides a good knowledge in the intended learning area. I would like to see more courses like this in future.",
    "This was a great course. Although the instructors couldn't touch all the aspects, guiding the students on what to follow and refer to is a great thing. Grateful for the organizers and instructors sharing their knowledge. Hope to join the next courses as well.",
    "The personal ML/embedded projects that the instructors shared as case studies were really inspiring. Sharing the ups and downs and what to expect along this path is a real motivator!",
    "Flow of the content was really great. It will really help to beginners who are entering to ML & Edge computing.",
  ],
  facts: [],
  classSchedule: [],
  prerequisite:
    "The workshop does not require any prior experience in SoC Design, but assumes some prior knowledge of digital design fundamentals. This is an intermediate-level workshop and anyone interested can participate and get an idea of how to get started in this area. ",
  isCourseFlyer: true,
  flyer: {
    description:
      "Learn more about Analog CMOS IC Design workshop from the workshop announcement flyer",
    button: "View Flyer",
    image: socFlyer,
  },
  courseStatus: ECourseStatus.OLD,
  showTimer: false,
  isDifferentBullet: true,
  isResources: false,
  resourcesYoutubeLink: "https://www.youtube.com/@skillsurfedu",
  resourcesGitHubLink: "https://github.com/SkillSurf/introduction_genAI",
  timerDate: "2026-04-24 00:00",
  showSchedule: true,
};
